import State from "models/State"
import {connect} from "react-redux"
import {createSelector} from "reselect"
import {ColourwayData} from "../../models/productSummaryApi"
import {formatPdpLink, getToolTipTitleByType, formatTitle} from "../../utils/colourwayBuilders"
import getTitleUtil from "../../utils/getTitleUtil"
import {selectPriceType} from "../../utils/priceFormatter/selectPriceType"
import {SuitType, ProductType, REALM_HEADER, BundleType} from "../../config/constants"
import {getTileSummaryData} from "../../utils/getTileSummaryData"

const selectSummaryItemData = (state: State, itemNumber: string) => state.productSummary.summaryItemsData[itemNumber]
const selectRequest = (state: State) => state.request
const selectEnabledSearchDesc = (state: State) => state.productSummary.enabledSearchDesc
const selectUseProductAggregator = (state: State) => state.search.useProductAggregator

export const makeSelectProductSummaryItem = createSelector(
    [selectSummaryItemData, selectRequest, selectEnabledSearchDesc, selectUseProductAggregator],
    (summaryData, request, enabledSearchDesc, useProductAggregator) => {
        const {isEnglishLang, siteUrl} = request

        const {colourways, title: defaultTitle, department, type, fit} = summaryData

        const selectedColourway = colourways.find(colourway => colourway.s) as ColourwayData
        const linkUrl = formatPdpLink(siteUrl, selectedColourway.url)
        const getTitle = useProductAggregator
            ? selectedColourway?.t
            : getTitleUtil({
                  enabledSearchDesc,
                  title: defaultTitle,
                  selectedColourway,
                  fit,
                  department,
                  isEnglishLang,
                  type,
              })
        const textTitle = enabledSearchDesc
            ? selectedColourway?.t || ""
            : formatTitle({
                  title: defaultTitle,
                  selectedColourway,
                  fit,
                  department,
                  isEnglishLang,
              })

        return {
            linkUrl,
            title: getTitle,
            price: selectPriceType(selectedColourway.p, selectedColourway?.sp),
            colour: selectedColourway?.c,
            tooltipTitle: getToolTipTitleByType(type, {
                title: selectedColourway.t,
                defaultTitle: type === SuitType || type === BundleType ? defaultTitle : textTitle,
                colourwayItemNumber: selectedColourway.id,
                price: selectedColourway.p,
                salePrice: selectedColourway.sp,
                fit,
                selectedColourway,
                isEnglishLang,
            }),
            isPriceARange: selectedColourway?.p?.includes("-") || false,
        }
    },
)

export const mapStateToProps = (state: State, ownProps) => {
    const {
        productSummary: {
            enableBrandDisplay,
            enableReviewStars,
            enableSingleLineTitle,
            enableSingleLineBrandName,
            summaryItemsData,
        },
        text: {
            labels: {rating},
        },
        productSummaryTemplate,
        textAlignment,
    } = state

    const summaryData = getTileSummaryData(summaryItemsData, ownProps.itemNumber)

    const {
        isConfError,
        type: productType,
        colourways,
        brand,
        department,
        currencyCode,
        colourwaysHasSale,
        colourwaysHasStarRatingWithRangedPrice,
        numberOfAllColourways,
        colourwaysHasRating,
    } = summaryData
    const client = state.request.headers[REALM_HEADER] as string
    if (isConfError) {
        return {isConfError: true, itemNumber: ownProps.itemNumber, firstItemNumber: ownProps.itemNumber}
    }

    const selectedColourway = colourways.find(colourway => colourway.s) as ColourwayData

    return {
        template: productSummaryTemplate,
        itemNumber: ownProps.itemNumber,
        firstItemNumber: colourways[0]?.id,
        productType,
        enableBrandDisplay,
        brand,
        colourwaysHasSale,
        colourwaysHasStarRatingWithRangedPrice,
        currencyCode,
        department,
        isWasPriceARange: selectedColourway?.wp?.includes("-") || false,
        overallStarRating: selectedColourway.st || 0,
        ratingText: rating,
        enableReviewStars: enableReviewStars ? productType === ProductType : false,
        enableSingleLineTitle,
        numberOfAllColourways,
        colourwaysHasRating,
        enableSingleLineBrandName,
        client,
        textAlignment,
        colourways,
        ...makeSelectProductSummaryItem(state, ownProps.itemNumber),
    }
}

export default connect(mapStateToProps)
